import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Divider } from './Divider';
import { dayPages } from '../data/dayPages';
export function DayPreviewCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const slide = track.children[0] as HTMLElement | undefined;
      if (!slide) return;
      const step = slide.offsetWidth + 24;
      setActive(Math.min(dayPages.length - 1, Math.round(track.scrollLeft / step)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const goTo = (index: number) => {
    const track = trackRef.current;
    const slide = track?.children[index] as HTMLElement | undefined;
    if (!track || !slide) return;
    track.scrollTo({
      left: slide.offsetLeft - track.offsetLeft,
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-[#5B401F] py-20" aria-roledescription="carrusel" aria-label="Páginas del Método R.E.V.E.L.A." data-id="element-50" data-mp="35ekpd1tgnr1y">
      <div className="max-w-6xl mx-auto px-6" data-id="element-51" data-mp="2roh9qtp36vlh">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-white" data-id="element-52" data-mp="2rll9gyprnutv">
          Así es un día con el{' '}
          <span className="text-[#E0B756]" data-id="element-53" data-mp="3obcdppnv0wcv">MÉTODO R.E.V.E.L.A.</span>
        </motion.h2>

        <Divider data-id="element-54" data-mp="3ag0dx3uukfp3" />

        <div className="relative" data-id="element-55" data-mp="3fcqpbdvpin46">
          <div ref={trackRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-56" data-mp="3fbxt36udjg0a">
            {dayPages.map((page, index) => <div key={page.src} className="snap-start flex-shrink-0 w-[78%] sm:w-[calc((100%-1.5rem)/2)] lg:w-[calc((100%-3rem)/3)]" aria-label={`Página ${index + 1} de ${dayPages.length}`} data-id="element-57" data-mp="23vh8z07vkb73" data-mpi={index}>
                <img src={page.src} alt={page.alt} loading="lazy" className="w-full aspect-[1080/1530] object-cover rounded-xl ring-1 ring-[#E0B756]/60 shadow-2xl bg-[#F7F2E7]" data-id="element-58" data-mp="1b249cwwmjjzb" />
              </div>)}
          </div>

          <button type="button" onClick={() => goTo(Math.max(0, active - 1))} disabled={active === 0} aria-label="Página anterior" className="hidden md:flex absolute -left-5 top-1/2 -translate-y-1/2 w-11 h-11 items-center justify-center rounded-full bg-[#E0B756] text-[#3A2812] shadow-lg transition-opacity duration-150 disabled:opacity-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-59" data-mp="w4toiwy3d1qx">
            <ChevronLeft className="w-6 h-6" data-id="element-60" data-mp="2p27ebr6cpktg" />
          </button>
          <button type="button" onClick={() => goTo(Math.min(dayPages.length - 1, active + 1))} disabled={active >= dayPages.length - 1} aria-label="Página siguiente" className="hidden md:flex absolute -right-5 top-1/2 -translate-y-1/2 w-11 h-11 items-center justify-center rounded-full bg-[#E0B756] text-[#3A2812] shadow-lg transition-opacity duration-150 disabled:opacity-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-61" data-mp="2u1jyg45u8dsc">
            <ChevronRight className="w-6 h-6" data-id="element-62" data-mp="2g195mvkywp4j" />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-6" data-id="element-63" data-mp="2k4fdu8rn4qdn">
          {dayPages.map((page, index) => <button key={page.src} type="button" onClick={() => goTo(index)} aria-label={`Ir a la página ${index + 1}`} aria-current={active === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${active === index ? 'w-6 bg-[#E0B756]' : 'w-2 bg-[#E0B756]/40'}`} data-id="element-64" data-mp="3ri8z3uj1xa05" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}